import React from 'react';
import {createPortal} from 'react-dom';
import {useNavigate} from 'react-router-dom';
import {ROUTES} from 'app/router/routes';
import styles from './EmploymentMismatchModal.module.css';

const MISMATCH_TEXT = 'Типы занятости исполнителя не соответствуют типам занятости заказа';

export type EmploymentMismatchModalProps = {
	isOpen: boolean;
	onClose: () => void;
};

function CloseIcon(): React.ReactElement {
	return (
		<svg className={styles.closeIcon} viewBox="0 0 24 24" fill="none" aria-hidden>
			<path d="M4 4L20 20" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
			<path d="M4 20L20 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
		</svg>
	);
}

export function EmploymentMismatchModal({isOpen, onClose}: EmploymentMismatchModalProps): React.ReactElement | null {
	const navigate = useNavigate();
	const titleId = React.useId();

	React.useEffect(() => {
		if (!isOpen) return;

		const onKeyDown = (event: KeyboardEvent) => {
			if (event.key === 'Escape') onClose();
		};

		const previousOverflow = document.body.style.overflow;
		document.body.style.overflow = 'hidden';
		document.addEventListener('keydown', onKeyDown);

		return () => {
			document.body.style.overflow = previousOverflow;
			document.removeEventListener('keydown', onKeyDown);
		};
	}, [isOpen, onClose]);

	if (!isOpen) return null;

	return createPortal(
		<div className={styles.root} role="presentation">
			<div className={styles.overlay} aria-hidden="true" onClick={onClose} />
			<div className={styles.container}>
				<div className={styles.panel} role="dialog" aria-modal="true" aria-labelledby={titleId}>
					<button type="button" className={styles.closeButton} onClick={onClose} aria-label="Закрыть">
						<CloseIcon />
					</button>
					<div className={styles.body}>
						<h2 id={titleId} className={styles.title}>
							Ошибка
						</h2>
						<p className={styles.description}>{MISMATCH_TEXT}</p>
					</div>
					<div className={styles.footer}>
						<button
							type="button"
							className={styles.confirmButton}
							onClick={() => {
								onClose();
								navigate(ROUTES.profileStatuses);
							}}
						>
							Подключения статусов
						</button>
					</div>
				</div>
			</div>
		</div>,
		document.body,
	);
}
